import { render } from "./PublicPage.vue?vue&type=template&id=2cc5d2cc"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__